document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.counter').forEach(function (element) {
		
	  var countTo = parseInt(element.getAttribute('data-countto'));

	  if( isNaN(countTo) ){
	  	return false;
	  }
	  var countDuration = parseInt(element.getAttribute('data-duration'), 10);
	  var counterObject = { counter: parseInt(0, 10) };

	  var animation = {
	    counter: countTo
	  }; 

	  var animationOptions = {
	    duration: countDuration,
	    easing: 'linear',
	    step: function () {
	      element.innerText = Math.floor(this.counter);
	    },
	    complete: function () {
	      element.innerText = countTo;
	    }
	  };

	  animateCounter(counterObject, animation, animationOptions);
	});

	function animateCounter(object, animation, options) {
	  var start = object.counter;
	  var startTime = performance.now();

	  function updateCounter(time) {
	    var progress = (time - startTime) / options.duration;

	    if (progress < 1) {
	      object.counter = start + animation.counter * progress;
	      options.step.call(object);
	      requestAnimationFrame(updateCounter);
	    } else {
	      object.counter = start + animation.counter;
	      options.step.call(object);
	      options.complete.call(object);
	    }
	  }
	  requestAnimationFrame(updateCounter);
	}
});